import { useContext } from "react";
import MainContext from "../../context/main/mainContext";

function extractErrorMessages(errors) {
  const messages = [];

  const walk = (value) => {
    if (!value) return;

    if (typeof value === "object" && value.message && typeof value.message === "string") {
      messages.push(value.message);
      return;
    }

    if (typeof value === "object") {
      Object.values(value).forEach(walk);
    }
  };

  walk(errors);
  return messages;
}

export default function ActionsBar({
  isLoading,
  onReset,
  onSubmitText,
  onOpenStripePaymentModal,
  errors,
}) {
  const { stripe_customer_payment_methods } = useContext(MainContext);
  const errorMessages = extractErrorMessages(errors);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <button
          id="submit-button"
          type="submit"
          disabled={isLoading || !!errorMessages.length}
          className="inline-flex items-center justify-center px-6 py-2.5 border border-gray-300 bg-gray-800 hover:bg-gray-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors disabled:opacity-50 disabled:cursor-auto disabled:hover:bg-gray-800"
        >
          {isLoading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Saving...
            </>
          ) : (
            onSubmitText
          )}
        </button>

        <button
          id="reset-button"
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center px-6 py-2.5 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg shadow-sm transition-colors"
        >
          Reset
        </button>
        {stripe_customer_payment_methods && (
          <button
            id="add-payment-method-button"
            type="button"
            onClick={onOpenStripePaymentModal}
            className="inline-flex items-center justify-center px-6 py-2.5 border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 text-sm font-medium rounded-lg shadow-sm transition-colors disabled:bg-white disabled:cursor-auto"
            disabled={isLoading || stripe_customer_payment_methods?.length}
          >
            {stripe_customer_payment_methods?.length ? "Card on file" : "Add Payment Method"}
          </button>
        )}
      </div>

      <div className="flex flex-col gap-1 text-red-600 mt-4">
        {errorMessages.map((message, index) => (
          <div key={index} className="text-xs text-red-600">
            {`${message}\n`}
          </div>
        ))}
      </div>
    </div>
  );
}
